import { set } from 'vue'

export const state = () => ({
    tags: {},
})

export const mutations = {
    SET_TAGS(state, { tag, data }) {
        set(state.tags, tag, data)
    },
}

export const actions = {
    async getTags({}, payload) {
        const result = await this.$axios.$get(`/api/v1/tag-groups`, { params: payload })
        return result?.data?.[0]?.tags || []
    },
    async getLanguages({ dispatch }, params) {
        return await dispatch('getTags', {
            ...params,
            q: 'language',
        })
    },
    async getGroupTags({ dispatch, commit, state }, tag) {
        if (!tag) throw new Error('Error: [tagGroups/getGroupTags] - missing tag')
        if (state.tags[tag]) return state.tags[tag]
        const result = await dispatch('getTags', { q: tag })
        commit('SET_TAGS', { tag: tag, data: result })
        return result
    },
}

export const getters = {
    tags: (state) => state.tags,
    all: (state) => Object.values(state.tags || {})?.flat() || [],
}
